export const calculateServiceLevel = () => {
  const porcentFormat = (data) => {
    const porcentNumberFormat = data.serviceLevel.replace(/\D/g, '').trim();
    return parseInt(porcentNumberFormat, 10);
  };

  const calculeConform = (data) => {
    if (!Array.isArray(data)) return 0;
    const porItem = data.map((calls) => {
      if (!calls || !calls.answered || !calls.serviceLevel) return 0;
      const serviceLevel = porcentFormat(calls);
      return Math.floor(calls.answered * (serviceLevel / 100));
    });
    return porItem.reduce((acc, val) => acc + val, 0);
  };

  const calculeNotConfor = (data) => {
    if (!Array.isArray(data)) return 0;

    const porItem = data.map((calls) => {
      if (!calls || !calls.answered || !calls.serviceLevel) return 0;
      const serviceLevel = porcentFormat(calls);
      const conform = Math.floor(calls.answered * (serviceLevel / 100));
      return calls.answered - conform;
    });
    return porItem.reduce((acc, val) => acc + val, 0);
  };

  return { calculeConform, calculeNotConfor };
};
